namespace AgerLMS.Administration {
    export interface SiteSettingsRow {
        SettingId?: number;
        SettingKey?: string;
        SettingName?: string;
        SettingData?: string;
    }

    export namespace SiteSettingsRow {
        export const idProperty = 'SettingId';
        export const nameProperty = 'SettingName';
        export const localTextPrefix = 'Administration.SiteSettings';
        export const deletePermission = 'LMS:SiteSetting:Modify';
        export const insertPermission = 'LMS:SiteSetting:Modify';
        export const readPermission = 'LMS:SiteSetting:Read';
        export const updatePermission = 'LMS:SiteSetting:Modify';

        export declare const enum Fields {
            SettingId = "SettingId",
            SettingKey = "SettingKey",
            SettingName = "SettingName",
            SettingData = "SettingData"
        }
    }
}
